import Dimensions from '../../../../../common/components/Dimensions.js'
import {
  shippedDimensionsSelector,
  showShippedDimensionsSelector,
  isShippedMultiboxSelector,
} from '../../../../../data/orders.js'
import {useSelector} from '../../../../../store.js'
import LabelItem from './LabelItem.js'

export default function ShippedDimensions({orderNumber}) {
  const showDimensions = useSelector((state) =>
    showShippedDimensionsSelector(state, {
      orderNumber,
      packagesIndex: 0,
    }),
  )
  const dimensions = useSelector((state) =>
    shippedDimensionsSelector(state, {
      orderNumber,
      packagesIndex: 0,
    }),
  )
  const isMultibox = useSelector((state) =>
    isShippedMultiboxSelector(state, {orderNumber}),
  )

  if (isMultibox) {
    return null
  }

  const values = showDimensions ? dimensions : {blankText: 'N/A'}
  return (
    <LabelItem label="Dimensions">
      <Dimensions {...values} />
    </LabelItem>
  )
}
